// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.roC72{width:400px}.Not3M{display:flex;flex-direction:row;gap:4px}.Not3M ._FZ3S{display:flex;flex-direction:row}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"autocompleteWrapper": `roC72`,
	"accountToSetColumn": `Not3M`,
	"textWrapper": `_FZ3S`
};
export default ___CSS_LOADER_EXPORT___;
